import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ServicesPage from "@/pages/services/page";
import AITechnologyPage from "@/pages/ai-technology/page";
import HowItWorksPage from "@/pages/how-it-works/page";
import PricingPage from "@/pages/pricing/page";
import CaseStudiesPage from "@/pages/case-studies/page";
import FAQPage from "@/pages/faq/page";
import ContactPage from "@/pages/contact/page";
import AboutPage from "@/pages/about/page";
import VisionaryPage from "@/pages/visionary/page";
import StrategiesPage from "@/pages/strategies/page";
import PartnersPage from "@/pages/partners/page";
import KarnatakaCitiesPage from "@/pages/karnataka-cities/page";
import CityLandingPage from "@/pages/karnataka-cities/city/page";
import ListingsPage from "@/pages/listings/page";
import ListingDetailPage from "@/pages/listings/detail/page";
import FeasibilityReportPage from "@/pages/feasibility-report/page";
import PressPage from "@/pages/press/page";
import SubmitPropertyPage from "@/pages/submit-property/page";
import NotFound from "@/pages/NotFound";

// Admin
import AdminLoginPage from "@/pages/admin/page";
import AuthGuardLayout from "@/components/feature/AuthGuardLayout";

// Members
import MembersLoginPage from "@/pages/members/page";
import MemberAuthGuardLayout from "@/components/feature/MemberAuthGuardLayout";
import MembersPortalPage from "@/pages/members/portal/page";

// SaaS Dashboard pages
import DashboardPage from "@/pages/dashboard/page";
import DashboardPropertiesPage from "@/pages/dashboard/properties/page";
import DashboardCRMPage from "@/pages/dashboard/crm/page";
import DashboardUsersPage from "@/pages/dashboard/users/page";
import DashboardContentPage from "@/pages/dashboard/content/page";
import DashboardMediaPage from "@/pages/dashboard/media/page";
import DashboardReportsPage from "@/pages/dashboard/reports/page";
import DashboardTransactionsPage from "@/pages/dashboard/transactions/page";
import DashboardSettingsPage from "@/pages/dashboard/settings/page";

// New admin pages
import DashboardLeadsPage from "@/pages/dashboard/leads/page";
import DashboardCRMAnalyticsPage from "@/pages/dashboard/crm-analytics/page";
import DashboardMenuSettingsPage from "@/pages/dashboard/menu-settings/page";
import DashboardApiStatusPage from "@/pages/dashboard/api-status/page";
import DashboardProfilePage from "@/pages/dashboard/profile/page";
import DashboardAuditPage from "@/pages/dashboard/audit/page";
import DashboardAnalyticsPage from "@/pages/dashboard/analytics/page";
import DashboardLeadDetailPage from "@/pages/dashboard/leads/detail/page";
import DashboardSecurityPage from "@/pages/dashboard/security/page";
import JDAServicePage from "@/pages/services/jda/page";
import LeasingServicePage from "@/pages/services/leasing/page";
import FranchiseServicePage from "@/pages/services/franchise/page";
import LandAsEquityServicePage from "@/pages/services/land-as-equity/page";
import SellPropertyPage from "@/pages/services/sell-property/page";
import RedevelopmentPage from "@/pages/services/redevelopment/page";
import ValuationPage from "@/pages/services/valuation/page";
import LegalPage from "@/pages/services/legal/page";
import ConstructionPage from "@/pages/services/construction/page";
import DigitalMarketingPage from "@/pages/services/digital-marketing/page";

const routes: RouteObject[] = [
  // ── Public marketing site ──────────────────────
  { path: "/", element: <HomePage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/services/jda", element: <JDAServicePage /> },
  { path: "/services/leasing", element: <LeasingServicePage /> },
  { path: "/services/franchise", element: <FranchiseServicePage /> },
  { path: "/services/land-as-equity", element: <LandAsEquityServicePage /> },
  { path: "/services/sell-property", element: <SellPropertyPage /> },
  { path: "/services/redevelopment", element: <RedevelopmentPage /> },
  { path: "/services/valuation", element: <ValuationPage /> },
  { path: "/services/legal", element: <LegalPage /> },
  { path: "/services/construction", element: <ConstructionPage /> },
  { path: "/services/digital-marketing", element: <DigitalMarketingPage /> },
  { path: "/karnataka-cities", element: <KarnatakaCitiesPage /> },
  { path: "/karnataka-cities/:citySlug", element: <CityLandingPage /> },
  { path: "/listings", element: <ListingsPage /> },
  { path: "/listings/:id", element: <ListingDetailPage /> },
  { path: "/ai-technology", element: <AITechnologyPage /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/case-studies", element: <CaseStudiesPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/visionary", element: <VisionaryPage /> },
  { path: "/strategies", element: <StrategiesPage /> },
  { path: "/partners", element: <PartnersPage /> },
  { path: "/feasibility-report", element: <FeasibilityReportPage /> },
  { path: "/press", element: <PressPage /> },
  { path: "/submit-property", element: <SubmitPropertyPage /> },

  // ── Admin login (public) ──────────────────────
  { path: "/admin", element: <AdminLoginPage /> },

  // ── Members login (public) ────────────────────
  { path: "/members", element: <MembersLoginPage /> },

  // ── Members portal (protected) ────────────────
  {
    path: "/members/portal",
    element: <MemberAuthGuardLayout />,
    children: [
      { index: true, element: <MembersPortalPage /> },
    ],
  },

  // ── SaaS Dashboard (protected, staff only) ────
  {
    path: "/dashboard",
    element: <AuthGuardLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "properties", element: <DashboardPropertiesPage /> },
      { path: "crm", element: <DashboardCRMPage /> },
      { path: "leads", element: <DashboardLeadsPage /> },
      { path: "users", element: <DashboardUsersPage /> },
      { path: "content", element: <DashboardContentPage /> },
      { path: "media", element: <DashboardMediaPage /> },
      { path: "reports", element: <DashboardReportsPage /> },
      { path: "transactions", element: <DashboardTransactionsPage /> },
      { path: "settings", element: <DashboardSettingsPage /> },
      { path: "crm-analytics", element: <DashboardCRMAnalyticsPage /> },
      { path: "analytics", element: <DashboardAnalyticsPage /> },
      { path: "menu-settings", element: <DashboardMenuSettingsPage /> },
      { path: "api-status", element: <DashboardApiStatusPage /> },
      { path: "profile", element: <DashboardProfilePage /> },
      { path: "audit", element: <DashboardAuditPage /> },
      { path: "security", element: <DashboardSecurityPage /> },
      { path: "leads/:leadId", element: <DashboardLeadDetailPage /> },
    ],
  },

  // ── 404 ───────────────────────────────────────
  { path: "*", element: <NotFound /> },
];

export default routes;